import React, { Fragment } from 'react';
import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';
import { Icon } from 'legacy-packages/ft-cb';
import './ChartLegend.scss';

export const COPY = {
  DEVELOPING: {
    TEACHER_SUMMARY:
      'Students who fall within the Developing performance category scored 0 - 39% on the exam. These students are showing success with some of the course learning objectives.',
    STUDENT_REPORT:
      'Students who fall within the Developing performance category scored 0 - 39% on the final exam.',
  },
  APPROACHING: {
    TEACHER_SUMMARY:
      'Students who fall within the Approaching performance category scored 40 - 74% on the exam.',
    STUDENT_REPORT:
      'Students who fall within the Approaching performance category scored 40 - 74% on the exam.',
  },
  ACHIEVING: {
    TEACHER_SUMMARY:
      'Students who fall within the Achieving performance category scored 75 - 100% on the exam.',
    STUDENT_REPORT:
      'Students who fall within the Achieving performance category scored 75 - 100% on the exam.',
  },
};

const icon = <Icon name="circle_help" width="16px" height="16px" />;

const ChartLegend = ({ data }) => (
  <Fragment>
    {
      <ul className="chart-list">
        {data.map(({ title, color }, i) => (
          <li className={color} key={`chart-list-${i}`}>
            <span>{title}</span>
            {icon && (
              <InformationalPopover
                icon={icon}
                key={`icon_${i}`}
                size={'normal'}
                message={COPY[title.toUpperCase()].TEACHER_SUMMARY}
                isHTML
              />
            )}
          </li>
        ))}
      </ul>
    }
  </Fragment>
);

export default ChartLegend;
